const elements = {
    breadcrumbs: 'slot[name=breadcrumbs]',
    
    wishlistQuantity: '.wishlist-quantity',
	cartQuantity: '.cart-quantity',
    flyoutSection: '.flyout-cart-wrapper',
    
    archivePage: '.es-archive', // * note: class name
    footer: '.es-footer', // * note: class name 
    compareProductsPage: 'es-compare-products',
	vendorPage: 'es-vendor',
	recentlyViewedProductsPage: 'es-recently-viewed-products',
	newProductsPage: 'es-new-products',
	productsByTagPage: 'es-products-by-tag',
};

export { elements }
export default elements